import { getPerformanceObject } from '../../../utils/window-helper';
export const bundleEvalTimings = (data, bundleEvalTimings, performance = getPerformanceObject() || undefined) => {
  if (!bundleEvalTimings) {
    return null;
  }
  const started = {};
  const timings = {};
  performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('mark').forEach(mark => {
    const result = bundleEvalTimings.mapPerformanceMark(mark.name);
    if (!result || data.result.startTime === null) {
      return;
    }
    const {
      type,
      name
    } = result;
    if (type === 'start' && mark.startTime >= data.result.startTime) {
      started[name] = mark;
      return;
    }
    if (type === 'end' && started[name]) {
      timings[name] = {
        startTime: Math.round(started[name].startTime - data.result.startTime),
        duration: Math.round(mark.startTime - started[name].startTime)
      };
      delete started[name];
    }
  });
  if (bundleEvalTimings !== null && bundleEvalTimings !== void 0 && bundleEvalTimings.additionalTimings && data.result.startTime !== null) {
    const result = bundleEvalTimings.additionalTimings(data.result.startTime);
    if (result) {
      Object.entries(result).forEach(([key, value]) => {
        timings[key] = value;
      });
    }
  }
  if (Object.keys(timings).length === 0) {
    return null;
  }
  return {
    'timings:bundleEval': timings
  };
};